/**
 * 5+1 Navigation structure for kevinjlope.dev v2.
 *
 * Primary (5): Home, About, Experience, Work, Blog
 * More (2)   : kevin-bot, Contact
 *
 * Now and Talks are hidden from the nav for now — their routes (/now, /talks)
 * still work, they are just not linked. Re-add the entries below to restore.
 *
 * The active nav item is derived from `useLocation()` in `Header`,
 * NOT from intersection observers — see HANDOFF.md "Information Architecture".
 */

export const PRIMARY_NAV = [
  { id: "home", href: "/", labelKey: "nav.home" },
  { id: "about", href: "/about", labelKey: "nav.about" },
  { id: "experience", href: "/experience", labelKey: "nav.experience" },
  { id: "work", href: "/work", labelKey: "nav.work" },
  { id: "blog", href: "/blog", labelKey: "nav.blog" },
] as const;

export const SECONDARY_NAV = [
  // { id: "now", href: "/now", labelKey: "nav.now" },
  // { id: "talks", href: "/talks", labelKey: "nav.talks" },
  { id: "kevinBot", href: "/kevin-bot", labelKey: "nav.kevinBot" },
  { id: "contact", href: "/contact", labelKey: "nav.contact" },
] as const;

export type PrimaryNavItem = (typeof PRIMARY_NAV)[number];
export type SecondaryNavItem = (typeof SECONDARY_NAV)[number];

/**
 * Map a pathname to either a primary nav id, "More", or null.
 * Used by Header to drive the active pill state.
 */
export const getActiveNav = (pathname: string): string | null => {
  if (pathname === "/" || pathname === "") return "home";
  if (pathname.startsWith("/about")) return "about";
  if (pathname.startsWith("/experience")) return "experience";
  if (pathname.startsWith("/work")) return "work";
  if (pathname.startsWith("/blog")) return "blog";
  if (
    pathname.startsWith("/now") ||
    pathname.startsWith("/talks") ||
    pathname.startsWith("/kevin-bot") ||
    pathname.startsWith("/contact")
  ) {
    return "More";
  }
  return null;
};
